export default "__VITE_ASSET__e5de28ff__"